import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class NpsService {

    private baseEndpoint;
    showNps = false;
    public questions;

    constructor(private httpClient: HttpClient) {
        this.baseEndpoint = environment.apiUser
    }

    getNps(userId) {
        const url = `${this.baseEndpoint}/nps/${userId}`;
        this.httpClient.get(url).subscribe((response: any) => {
            this.questions = response?.questions ? response.questions : []
            this.showNps = !response?.answered && response.questions.length > 0;
        })
    }


    closeNps() {
        this.showNps = false;
    }

    sendNpsRequest(questionId, option): Observable<any> {
        const url = `${this.baseEndpoint}/nps/answer`;
        return this.httpClient.post(url, {questionId, option})
    }

}
